import React from "react";
import PushNotification from "./components/snackBar/snackBar.container";
import { addAlert, setLoading, selectLoading } from "./redux";

export default function Notification() {
  return <PushNotification />;
}

export { addAlert, setLoading, selectLoading };
